import Button from '@mui/material/Button';
import { CloudUploadOutlined } from '@mui/icons-material';
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Tooltip } from '@mui/material';
import QuestionsListInput from './QuestionsListInput';

function BulkQuestionUpload({
    open,
    setOpen,
    type,
    setShowActions,
}: {
    open: boolean;
    setOpen: any;
    type: any;
    setShowActions: any;
}) {
    const handleClose = () => {
        setOpen(false);
        setShowActions?.(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={false}
            sx={{ '& .MuiDialog-paper': { width: '80vw', maxWidth: '80vw' } }}
        >
            <DialogTitle>Select Questions</DialogTitle>
            <DialogContent className="">
                <QuestionsListInput
                    handleClose={handleClose}
                    onSuccess={(key: string) => {
                        handleClose();
                    }}
                    type={type}
                />
            </DialogContent>
        </Dialog>
    );
}

export const BulkUploadSectionQuestions = ({ type, setShowActions }: any) => {
    const [open, setOpen] = React.useState(false);
    return (
        <>
            <BulkQuestionUpload
                open={open}
                setOpen={setOpen}
                type={type}
                setShowActions={setShowActions}
            />
            <Tooltip title="Upload Questions">
                <Button
                    sx={{ paddingBottom: '0' }}
                    className="gap-3 pb-0"
                    onClick={() => {
                        setOpen(true);
                    }}
                >
                    <CloudUploadOutlined />
                    Add Questions Via QB
                </Button>
            </Tooltip>
        </>
    );
};
